import React from 'react';
import { Button, Layout } from 'antd';
import AppLayout from '../components/AppLayout';
import { Link } from 'react-router-dom';
import ProceedingListPage from './ProceedingListPage';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { Content } from 'antd/es/layout/layout';

export default function HomePage() {
  return (
    <>
      <Layout style={{ minHeight: '100vh' }}>
        <AppLayout />
        <Layout>
          <Content style={{ margin: '16px' }}>
            <div style={{ padding: '24px', background: '#fff', minHeight: '360px' }}>
              <AuthenticatedTemplate>
                <div style={{ height: 10 }}></div> {/* This div acts as a spacer */}
                <ProceedingListPage />
              </AuthenticatedTemplate>
              <UnauthenticatedTemplate>
                <ProceedingListPage />
              </UnauthenticatedTemplate>
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
}
